<template>
	<v-app id="inspire" class="white">
        <v-bottom-sheet v-model="sheet">
            <Boleto ></Boleto>
        </v-bottom-sheet>

        <InformeLGPD :dialogVisible="getShowInformeLGPD" />

        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="teal darken-1">
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Suporte - Agência 56K</v-toolbar-title>
                </v-toolbar>
                <v-card flat >
                    <Zendesk></Zendesk>
                </v-card>
            </v-card>
        </v-dialog>
        <v-snackbar :color="snackbar.color" v-model="snackbar.visible" :bottom="'bottom'" :right="'right'" :timeout="snackbar.timeout">{{snackbar.message}}
            <v-btn color="white" flat @click="snackbar.visible=false">Fechar</v-btn>
        </v-snackbar>



        <v-toolbar color="teal darken-1" v-if="$route.name!='login' && $route.name!='404' && $route.name != 'criar-conta'" :clipped-left="true" dark app fixed>
            <v-toolbar-side-icon @click.stop="drawer=!drawer" ></v-toolbar-side-icon>
            <v-toolbar-title >

                <img :src="require('./assets/logo.png')" width="125"  />

            </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-toolbar-items class="hidden-sm-and-down">
                <span style="margin: auto;" v-if="getUserLocal.operator === 'whatsapp'">Mensagens serão enviadas via Whatsapp</span>
                <v-btn v-else flat @click="$router.push('/comprarcreditos')" class="title">Créditos: {{ getUserLocal.credits || 0 }}</v-btn>
                <!--<v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small class="elevation-0 teal lighten-1" v-on="on" @click="dialog=true, buscaTickets()">
                            <v-icon size="20">headset_mic</v-icon>
                        </v-btn>

                    </template>
                    <span class="title">Suporte</span>
                </v-tooltip>-->
              </v-toolbar-items>
              <v-chip color="white" text-color="black">
                <v-icon left>people</v-icon> {{ getUser.empresa_nome || "Sem nome" }}
              </v-chip>
        </v-toolbar>


        <v-navigation-drawer
            v-if="$route.name!='login' && $route.name!='404' && $route.name != 'criar-conta'"
            :clipped="true"
            v-model="drawer"
            hide-overlay
            stateless
            app
        >
            <v-list class="pa-2" two-line="two-line">
                <template v-for="(item, index) in menuFiltrado">
                    <v-list-tile :key="item.nome" avatar="avatar" @click="rotear(item.rota)" :style="{backgroundColor: routerActive(item) }">
                        <v-list-tile-avatar>
                            <img :src="require('./assets/'+ item.icon )" style="filter:grayscale(100%);"/>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title v-html="item.nome == 'Dashboard' ? 'Informes' : item.nome == 'Documentação' ? 'Integração' : item.nome" style="color:#3d3d3d;text-transform:uppercase;"></v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider :key="index"></v-divider>
                </template>
            </v-list>
        </v-navigation-drawer>


        <v-content>
            <transition name="component-fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </v-content>
    </v-app>
</template>

<script>
import Boleto from './components/user/modais/Boleto'
import Zendesk from './components/user/modais/Zendesk'
import { mapGetters, mapActions } from 'vuex'
import io from 'socket.io-client'
import config from '../config.json'

import InformeLGPD from './components/InformeLGPD'

export default {
    components:{
        Boleto,
        Zendesk,
        InformeLGPD
    },
    data: () => ({
        sheet:false,
        drawer: true,
        dialog: false,
        snackbar: {
            visible:false,
            timeout:3000,
            message: '',
            color:'light-blue darken-4'
        },
        statusSocket: false,
        linkQueroTaxi: true
    }),
    async mounted()
    {
        console.log(this.$vuetify.breakpoint)
        this.subroutes(this.$router.options.routes.filter( r => r.meta && 'subroutes' in r.meta ))
        this.$eventHub.on('snackBar', config => {
            this.snackbar.visible = true
            this.snackbar.timeout = config.timeout
            this.snackbar.message = config.message
            this.snackbar.color   = config.color
        })
        if(!this.statusSocket && this.$route.name != 'login')
        {
            this.statusSocket = true
            //this.initSocket()
            //console.log('não tem socket')
        }

        //console.log('tem socket')

        //this.loadUserLocal()
    },
    watch: {
        '$route.name'() {
            if(this.$route.name != 'login')
                if(!this.statusSocket)
                {
                    this.statusSocket = true
                    //this.initSocket()
                    //console.log(this.$route.name, 'sem socket')
                }
        },

        async 'getUserLocal.key'(val) {
            if(val) {
                const { status } = await this.isClientQueroTaxi(val)
                if(!status) {
                    this.linkQueroTaxi = false
                } else {
                    this.linkQueroTaxi = true
                }
            }
        }
    },
    methods:{
      ...mapActions(['logout', 'subroutes', 'findTickets', 'loadUserLocal', 'isClientQueroTaxi']),
      async rotear(r)
      {
        if(r == "login") await this.logout()
        this.$router.push(r)

      },
      routerActive(r)
      {
        if(r.rota == this.$route.name || this.$route.matched[0].meta.subroutes && this.$route.matched[0].meta.subroutes.includes(this.$route.name) && this.$route.matched[0].name == r.rota.split('/').join('')  ) return "#eee"
        return '#fff'
      },

      async buscaTickets()
      {
        await this.findTickets()
      },
      initSocket()
      {
        let socket = io(config.api_socket, {
                query: {token: this.$store.getters.getToken ? this.$store.getters.getToken : sessionStorage.getItem("token") },
                transports: ['websocket'],
                secure: true,
        })

        socket.on('connect', () => {
            //console.log('conectado')
        })


        socket.on('sms_enviado', (data) => {
            this.getUserLocal.credits = this.getUserLocal.credits-1
        })
      }
    },
    computed:{
        ...mapGetters(['getMenu', 'getChildren', 'getToken', 'getUser', 'getUserLocal', 'getShowInformeLGPD']),
        getUserLocal () {
          return this.$store.getters.getUserLocal
        },
        menuFiltrado()
        {
            if(this.linkQueroTaxi) {
                return [ "sumarios", "mensagens", /*"comprarcreditos",*/ "push", "torpedovoz", "pxtalk", "documentacao", "perfilempresa", "listar-clientes", "menuprotaxi", "historicotransacoes", "quero-taxi", "login" ].map( _ => this.getMenu.find( b => b.rota == _ ) ).filter( _ => _)
            }
            return [ "sumarios", "mensagens", /*"comprarcreditos",*/ "push", "torpedovoz", "pxtalk", "documentacao", "perfilempresa", "listar-clientes", "menuprotaxi", "historicotransacoes", "login" ].map( _ => this.getMenu.find( b => b.rota == _ ) ).filter( _ => _)
        }
        /*filteredMenu()
        {
            let filhas    = this.getChildren
            let subroutes = this.$router.options.routes.filter( r => r.meta && 'subroutes' in r.meta )
            subroutes     = subroutes.map( f => {
                return (f.meta && f.meta.subroutes) ? {subroutes:f.meta.subroutes, name: f.name} : null
            })
            subroutes     = subroutes.map( s => {
                if(
                    s.subroutes.filter( ch => {
                        let fi = filhas.find( f => f.rota == ch )

                        if( fi )
                            return fi.acoes.filter( a => a.status ).length > 0

                    }).length > 0
                )
                return {name:s.name, status:true}
                else return {name:s.name, status:false}
            })
            let permitidos = this.getMenu.filter( m => subroutes.find(  s => s.name == m.rota && s.status == true ) )
            let resto      = this.getMenu.filter( m => !subroutes.find(  s => s.name == m.rota ) )
            return resto.concat(permitidos, [{icon:"loggout.png", nome: "Fazer Logout", rota:"login"}] )
        }*/
    }
 }
</script>


<style>
  .fonte {
    color: #77bdb6 !important;
  }
  .fundo {
    background-color: #00897b !important;
    color: #FFF !important;
  }
  .color {
    color: #00897b !important;
  }
  * {
    font-weight: normal;
    font-family: 'Quicksand', sans-serif;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    letter-spacing: 2px;
  }
  .vdatetime-input{
    border-bottom:1px solid #ccc;
    width: 100%;
  }
  .maxSize {
    width: 100%;
    box-sizing: border-box
  }
  .padding {
    padding: 50px;
  }
  .marginBottom {
    margin-bottom: 50px
  }
  .vdatetime-popup__header,
  .vdatetime-calendar__month__day--selected > span > span,
  .vdatetime-calendar__month__day--selected:hover > span > span {
    background: #00897b !important;
  }
  .vdatetime-popup__actions__button,
  .vdatetime-time-picker__item--selected {
    color: #00897b !important;
  }
  .input-datetime{
    border: 1px solid #000;
  }
  .topo {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #00897b;
  }
  .v-toolbstyle="background-color: $primaria"ar__content,
  .v-toolbar__extension {
    padding: 0px !important;
  }
  .component-fade-enter-active,
  .component-fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .component-fade-enter,
  .component-fade-leave-to {
    opacity: 0;
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>




// WEBPACK FOOTER //
// src/App.vue